///
/// EarthBrowser
///
/// Created by Matt Giger on 9/11/2024
/// Copyright (c) 2024 Geodata Labs
///

import { type RenderState } from "@stovokor/engine/RenderState"
import { rgba, type color } from "@stovokor/math/color"
import { type Texture } from "@stovokor/shader/Texture"

/**
 * The Material interface is the base class for all materials.
 *
 * Any uniform or DynamicUniforms properties in the shader will be discovered and extracted.
 * Therefore it is very important those are public and named the same as the uniforms in the shader.
 */
export interface Material {
	shaderDefines?: Record<string, string>
	transparency: boolean
	available: boolean

	renderUpdate?(state: RenderState): void
}

export class SimpleMaterial implements Material {
	public shaderDefines?: Record<string, string>
	public transparency: boolean = false
	public available: boolean = true
	public color: color

	constructor(color: color = rgba(1, 1, 1, 1)) {
		this.color = color
	}
}

export class SimpleTexMaterial implements Material {
	public shaderDefines?: Record<string, string>
	public transparency: boolean = false
	public texture0: Texture

	constructor(texture0: Texture) {
		this.texture0 = texture0
	}

	public get available(): boolean {
		return this.texture0.available
	}
}
